// Captains
import Christopher_Pike from '../assets/Christopher_Pike.avif';
import Elizabeth_Shelby from '../assets/Elizabeth_Shelby.avif';
import Gabriel_Lorca from '../assets/Gabriel_Lorca.webp';
import JeanLuc_Picard from '../assets/Jean-Luc_Picard.jpg';
import John_Harriman from '../assets/John_Harriman.avif';
import James_T_Kirk from '../assets/James_T_Kirk.jpg';
import Jonathan_Archer from '../assets/Jonathan_Archer.jpg';
import Kathryn_Janeway from '../assets/Kathryn_Janeway.jpg';
import Michael_Burnham from '../assets/Michael_Burnham.webp';
import Philippa_Georgiou from '../assets/Philippa_Georgiou.jpg';
import Rachel_Garrett from '../assets/Rachel_Garrett.webp';
import Saru from '../assets/Saru.avif';
import Seven_of_Nine from '../assets/seven_of_nine.avif';
import William_Riker from '../assets/William_Riker.jpg';
import Benjamin_Sisko from '../assets/Benjamin_Sisko.jpg';

// Ships
import USS_Enterprise from '../assets/USS_Enterprise.webp';
import USS_Sutherland from '../assets/USS_Sutherland.avif';
import USS_Discovery from '../assets/USS_Discovery.webp';
import USS_Enterprise_D from '../assets/USS_Enterprise_D.webp';
import USS_Enterprise_B from '../assets/USS_Enterprise_B.webp';
import USS_Voyager from '../assets/USS_Voyager.avif';
import USS_Titan from '../assets/USS_Titan.jpg';
import USS_Shenzhou from '../assets/uss_shenzhou.jpg';
import USS_Enterprise_NX01 from '../assets/USS_Enterprise_NX01.jpg';
import USS_Defiant from '../assets/USS_Defiant.jpg';

// Support Images
import star_trek_captains1 from '../assets/star-trek-captains.webp';
import Star_trek_captains2 from '../assets/Star-Trek-captains2.avif';
import star_trek_captains3 from '../assets/star-trek-captains3.avif';
import star_trek_captains4 from '../assets/Star-trek-captains4.jpg';
import star_trek_captains5 from '../assets/star-trek-captains5.avif';

// Named exports
 const captainImages = {
  'Benjamin Sisko': Benjamin_Sisko,
  'Christopher Pike': Christopher_Pike,
  'Elizabeth Shelby': Elizabeth_Shelby,
  'Gabriel Lorca': Gabriel_Lorca,
  'Jean-Luc Picard': JeanLuc_Picard,
  'John Harriman': John_Harriman,
  'James T. Kirk': James_T_Kirk,
  'Jonathan Archer': Jonathan_Archer,
  'Kathryn Janeway': Kathryn_Janeway,
  'Michael Burnham': Michael_Burnham,
  'Philippa Georgiou': Philippa_Georgiou,
  'Rachel Garrett': Rachel_Garrett,
  'Saru': Saru,
  'Seven of Nine': Seven_of_Nine,
  'William Riker': William_Riker,
};

 const shipImages = {
  'USS Enterprise': USS_Enterprise,
  'USS Sutherland': USS_Sutherland,
  'USS Discovery': USS_Discovery,
  'USS Enterprise-D': USS_Enterprise_D,
  'USS Enterprise-B': USS_Enterprise_B,
  'USS Voyager': USS_Voyager,
  'USS Titan': USS_Titan,
  'USS Shenzhou': USS_Shenzhou,
  'Enterprise NX-01': USS_Enterprise_NX01,
  'USS Defiant': USS_Defiant
};
 
 const supportImages = {
  'star-trek-captains.webp': star_trek_captains1,
  'Star-Trek-captains2.avif': Star_trek_captains2,
  'star-trek-captains3.avif': star_trek_captains3,
  'Star-trek-captains4.jpg': star_trek_captains4,
  'star-trek-captains5.avif': star_trek_captains5,
};

 const captainNames = [
  'Christopher Pike',
  'Elizabeth Shelby',
  'Gabriel Lorca',
  'Jean-Luc Picard',
  'John Harriman',
  'John T Kirk',
  'Jonathan Archer',
  'Kathryn Janeway',
  'Michael Burnham',
  'Philippa Georgiou',
  'Rachel Garrett',
  'Saru',
  'Seven of Nine',
  'William Riker',
];



export  {
  captainImages,
  shipImages,
  supportImages,
  captainNames
};